import Axios from 'axios'
import { driversUrls } from '../urls'
import router from '../../../router'

export default {
  get_all_drivers(context) {
    Axios.get(driversUrls.getAllDrivers).then(function (response) {
      context.commit('GET_ALL_DRIVERS', response.data)
    }).catch(function (error) {
      console.error('Error fetching drivers:', error)
    })
  },

  get_driver(context, id) {
    Axios.get(driversUrls.getDriver + id).then(function (response) {
      context.commit('GET_DRIVER', response.data)
    }).catch(function (error) {
      console.error('Error fetching driver:', error)
    })
  },

  // Note: get_drivers might not be needed since get_all_drivers does the same
  get_drivers(context, publicId) {
    Axios.get(driversUrls.getDrivers + publicId).then(function (response) {
      context.commit('GET_DRIVERS', response.data)
    })
  },

  post_driver(context, data) {
    Axios.post(driversUrls.postDriver, data).then(function () {
      context.dispatch('get_all_drivers')
    }).catch(function (error) {
      // Fixed error handling without optional chaining
      const errorMsg = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : ['Error adding driver'];
      context.commit('DRIVER_ERRORS', errorMsg)
    })
  },

  update_driver(context, data) {
    Axios.patch(driversUrls.editDriver, data).then(function () {
      context.dispatch('get_all_drivers')
    }).catch(function (error) {
      const errorMsg = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : ['Error updating driver'];
      context.commit('DRIVER_ERRORS', errorMsg)
    })
  },

delete_driver(context, data) {
  return new Promise((resolve, reject) => {
    Axios.patch(driversUrls.deleteDriver, data).then(function(response) {
      context.dispatch('get_all_drivers');
      resolve(response);  // Return the response to the component
    }).catch(function(error) {
      const errorMsg = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : ['Error deleting driver'];
      context.commit('DRIVER_ERRORS', errorMsg);
      reject(error);  // Return the error to the component
    });
  });
},

  // Optional: Update existing drivers with public IDs
  update_drivers_public_ids(context) {
    Axios.post(driversUrls.updatePublicIds).then(function (response) {
      alert(response.data.message[0])
      context.dispatch('get_all_drivers')
    }).catch(function (error) {
      const errorMsg = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : ['Error updating public IDs'];
      context.commit('DRIVER_ERRORS', errorMsg)
    })
  }
}